import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header">
      <div className="container nav">
        <Link to="/" className="brand" aria-label="Thế Thảo Pharma — Chung tay vì một cuộc sống khoẻ đẹp" onClick={closeMenu}>
          <img src="/assets/img/logo-icon.svg" alt="" className="brand__icon" width="64" height="64" />
          <span className="brand__text">
            <span className="brand__name">THẾ THẢO PHARMA</span>
            <span className="brand__tagline">Chung tay vì một cuộc sống khoẻ đẹp</span>
          </span>
        </Link>

        <nav>
          <ul className={`nav-menu ${menuOpen ? 'open' : ''}`} id="navMenu">
            <li>
              <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                <svg className="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M3 10.5L12 3l9 7.5V20a1.5 1.5 0 0 1-1.5 1.5H15v-7H9v7H4.5A1.5 1.5 0 0 1 3 20z" />
                </svg>
                Trang chủ
              </NavLink>
            </li>
            <li>
              <NavLink to="/gioi-thieu" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                Giới thiệu
              </NavLink>
            </li>
            <li>
              <NavLink to="/tin-tuc" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                Tin tức &amp; Sự kiện
              </NavLink>
            </li>
            <li>
              <a href="https://chothuoc247.vn/" target="_blank" rel="noopener noreferrer">
                <svg className="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M3 6h18l-2 12a2 2 0 0 1-2 1.7H7A2 2 0 0 1 5 18L3 6z" />
                  <path d="M8 6V4a4 4 0 0 1 8 0v2" />
                </svg>
                Chothuoc247.vn
              </a>
            </li>
            <li>
              <NavLink to="/tu-thuoc-cho-em" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
                <svg className="nav-ico" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M12 21s-7-4.35-9.5-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 6c-2.5 4.65-9.5 9-9.5 9z" />
                </svg>
                Tủ thuốc cho em
              </NavLink>
            </li>
            <li className="nav-menu__cta">
              <NavLink to="/tuyen-dung" onClick={closeMenu}>
                <svg className="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M20 7h-4V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM10 5h4v2h-4zm10 14H4V9h16z" />
                </svg>
                Tuyển dụng
              </NavLink>
            </li>
          </ul>
        </nav>

        <div className="nav-cta">
          <Link className="btn btn--primary" to="/tuyen-dung">
            Tuyển dụng
          </Link>
          <button
            className="nav-toggle"
            aria-controls="navMenu"
            aria-expanded={menuOpen}
            aria-label="Mở menu"
            onClick={toggleMenu}
            type="button"
          >
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
}
